<template>
  <div class="hello">
    <PageBasicSet v-model="dataInfo" :ImageList="[]"  :basicBlockArr="blockArr" :cssBlockArr="[]"></PageBasicSet>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
        <div style="text-align: center;margin-top: 20px">
          <el-button type="success" @click="saveInfo" :loading="fullscreenLoading">保存</el-button>
          <!-- <el-button type="info" @click="cancelPage" >取消</el-button> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import PageBasicSet from '@/components/page/pageSet/PageBasicSet.vue';
export default {
  name: 'MongoObjectSet.',
  props: {
  },
  data() {
    return {
      sourceType:1,
      hasLoad:false,
      fullscreenLoading:false,
      //数据ID
      dataId:0,
      mongoName:"table",
      mongoIdName:"tableId",
      dataInfo:{},
      blockArr:[{blockCnName:"对象基础信息",
          fieldArr:[{
            cnName:"对象中文名称",enName:"tableCnName",type:2,ifMust:1
          },{
            cnName:"是否支持审批流",enName:"ifCheckFlow",type:1,dicList:[{label:"是",value:1},{label:"否",value:2}]
          }]
      }]
    };
  },
  created() {
    var paramsQuery = this.$route.query;
    if(paramsQuery.dataId > 0) {
      this.dataId = paramsQuery.dataId;
    }
    if(paramsQuery.sourceType > 0) {
      this.sourceType = paramsQuery.sourceType;
    }
    this.loadDataSet();
  },
  mounted() {
    
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
  },
  computed:{
  },
  components: {
    PageBasicSet
  },
  methods: {
    /**
     * 根据页面ID 加载页面设置信息
     */
    loadDataSet(){
      var that = this;
      //读取页面 的page对象
      var url = "/pageShowSet_loadMongoInfoById.do?source=1";
      var toHtData = {};
      toHtData.dataId = that.dataId;
      toHtData.mongoName = that.mongoName;
      toHtData.mongoIdName = that.mongoIdName;
      toHtData.sourceType = that.sourceType;
      that.loading = true;
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.loading = false;
          if (res.data != null) {
            that.dataInfo = res.data;
          }
          that.hasLoad = true;
        },
        fail: function () {
          that.loading = false;
          console.log("服务器异常!",error);
        }
      });
    },
    /**
     * 保存数据
     */
    saveInfo(){
      var that = this;
      var url = "/pageShowSet_saveMongoInfoById.do?source=1";
      var dataId = this.dataId;
      var toHtData = {};
      toHtData.dataId = dataId;
      toHtData.mongoName = that.mongoName;
      toHtData.mongoIdName = that.mongoIdName;
      toHtData.sourceType = that.sourceType;
      //进行vue新增设置的 另外保存设置 放置出现丢失的情况
      toHtData.jsonStr = JSON.stringify(that.dataInfo);
      this.fullscreenLoading = true;
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.fullscreenLoading = false;
          if(res.data > 0) {
            that.$message({
              showClose: true,
              message: "保存成功!",
              type: 'success'
            });
          } else {
            that.$message({
              showClose: true,
              message: "保存失败,请重试!",
              type: 'error'
            });
          }
        },
        fail: function () {
          console.log("error=====" + error);
        }
      });
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
